<template>
  <div class="flex justify-center gap-y-4 flex-col items-center">
    <ViceAvatar
      v-if="showImage"
      :class="minimizable ? 'w-16 h-16' : 'w-24 h-24'"
      :image="profile_photo_url"
      :name="name"
    />
    <p v-else class="flex flex-col items-center text-gray-200 text-center font-bold">
      <EyeOffIcon class="w-12 h-12 mb-2 text-vice-dark-grey text-sm" />
      {{ displayText }}
    </p>
    <!-- Bandwidth disabled indicator -->
    <div v-if="disabledByBandwidth" class="text-white text-sm mt-2 bg-yellow-600 px-2 py-1 rounded">
      Disabled to save bandwidth
    </div>
  </div>
</template>

<script>
import { EyeOffIcon } from '@heroicons/vue/outline';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';

export default {
  props: {
    name: {
      type: String,
    },
    profile_photo_url: {
      type: String,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    displayText: {
      type: String,
      default: '',
    },
    disabledByBandwidth: {
      type: Boolean,
      default: false,
    },
    minimizable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ViceAvatar,
    EyeOffIcon,
  },
};
</script>
